<script setup lang="ts">
import BlueButton from "../../components/BlueButton.vue";
import GreetingBlock from "../../components/GreetingBlock.vue";
import { locale } from "../../locale";
import { authState, checkCallExist, commitAuthState } from "../../states/auth";
import GreetingPage from "../templates/GreetingPage.vue";
import InputBox from "../../components/InputBox.vue";
import PreviewVideoNew from "../../components/PreviewVideoNew.vue";
import { roomState } from "../../states/room";
import SpinnerBtn from "../../components/preview/SpinnerBtn.vue";
import { nextTick, onMounted, ref } from "vue";
import {
  combineValidators,
  getEmptyFieldValidator,
  getMaxLenValidator,
} from "../../utils/validators";
import {
  requestEnter,
  selfApproved,
  setupApprovedSelfData,
} from "../../states/approveSelfEnterState";
import { goToWait } from "../../states/toWaitState";
import { transitionEvents } from "../../states/transitions";
import { useRouter } from "vue-router";
import { init } from "../../states/media/state";
import { roomStarted } from "../../states/viewState";
import { mediaActions } from "../../states/media/actions";

const router = useRouter();
transitionEvents.emit("start");

const initPromise = init();

const nameValidator = combineValidators([
  getEmptyFieldValidator(locale.validators.fieldnames.name).validator,
  getMaxLenValidator(600, locale.validators.fieldnames.name).validator,
]);
onMounted(() => {
  if (goToWait.value) {
    initPromise.finally(() => {
      mediaActions.microOff();
      mediaActions.cameraOff();
      run();
      goToWait.value = false;
      const newurl = window.location.href.replace("?wait=true", "");
      window.history.pushState(null, "", newurl);
    });
  }
});
const run = async () => {
  const exist = await checkCallExist();
  if (exist) {
    router.push({
      name: "error",
      params: {
        errtype: "call-exist",
      },
    });
    throw "exist another call";
  }
  authState.displayedName = authState.displayedName.trim();
  await new Promise((resolve) => {
    nextTick(() => resolve(null));
  });
  nameValidator.validator(authState.displayedName);
  if (!nameValidator.state.value) {
    input.value?.shake();
    return;
  }
  await commitAuthState();
  roomStarted.value = true;
  if (roomState.waitRoom) {
    await setupApprovedSelfData();
    if (!selfApproved.value) {
      await requestEnter();
    }
  }
};
const input = ref<typeof InputBox | null>(null);
</script>
<template>
  <GreetingPage class="create-meeting">
    <GreetingBlock :title="roomState.name">
      <div class="preview-block">
        <PreviewVideoNew />
      </div>
      <InputBox
        ref="input"
        v-model="authState.displayedName"
        :validator="nameValidator.validator"
        :title="locale.youname"
        :placeholder="locale.required"
      />
      <div class="controls" v-if="!roomStarted">
        <BlueButton @click="run">{{ locale.goconnect }}</BlueButton>
      </div>
      <div class="preload" v-else>
        <span
          class="text"
          v-if="['Created', 'Suspended'].includes(roomState.status)"
        >
          {{ locale.waitLeaderStart }}
        </span>
        <span class="text" v-else-if="!selfApproved">
          {{ locale.waitApprove }}
        </span>
        <SpinnerBtn />
      </div>
    </GreetingBlock>
  </GreetingPage>
</template>
<style scoped>
.blocked {
  cursor: wait;
}

.blocked * {
  pointer-events: none;
}

.controls {
  padding: 0 12px 0 0;
  display: flex;
  flex-direction: row-reverse;
}

.preload {
  width: 100%;
  display: flex;
  height: 36px;
  padding: 0 12px 0 60px;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
}

.preload .text {
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #747474;
}

.preview-block {
  padding: 12px;
  display: flex;
  gap: 24px;
  height: 220px;
  width: 100%;
  justify-content: center;
}

.right {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
}

.copy-btn-container {
  display: flex;
  flex-direction: row-reverse;
}
</style>
